/** Origens da atividade*/
export interface AtividadeLancamento {
    id: number;
    nome: string;
}

export const lancamentoManual: AtividadeLancamento = {id: 1, nome: 'Manual'};
export const lancamentoAutomatico: AtividadeLancamento = {id: 2, nome: 'Automatico'};

export const atividadeLancamentos: AtividadeLancamento[] = [
    lancamentoManual,
    lancamentoAutomatico
];


/** Verifica se o lançamento é manual */
export function isLancamentoManual(id: number): boolean {
    return id === lancamentoManual.id;
}

/** Verifica se o lançamento é automático */
export function isLancamentoAutomatico(id: number): boolean {
    return id === lancamentoAutomatico.id;
}
